import { get } from 'lodash';
import { createSelector } from 'reselect';
export var getWixData = function (state) { return state.wixData; };
export var getWixDataCategoryId = createSelector([getWixData], function (wixData) { return get(wixData, 'categoryId', null); });
export var getWixDataTagId = createSelector([getWixData], function (wixData) { return get(wixData, 'tagId', null); });
